import { render, staticRenderFns } from "./TabBudgetTransport.vue?vue&type=template&id=28c856ae&scoped=true"
import script from "./TabBudgetTransport.vue?vue&type=script&lang=ts"
export * from "./TabBudgetTransport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c856ae",
  null
  
)

export default component.exports